<app-base-modal
  title="Выбор даты"
  size="standard"
>
  @if (isLoading) {
    <app-loader/>
  }
  @if (dialogData) {
    <div class="container">
      <form
        class="form"
        [formGroup]="formGroup"
      >
        @for (field of releaseCalendarFormFields; track $index) {
          <mat-form-field appearance="outline">
            <mat-label>{{ field.label }}</mat-label>
            <mat-select [formControlName]="field.fieldName">
              @for (item of field.options; track item.value) {
                <mat-option
                  [value]="item.value"
                >
                  {{ item.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </form>
      <div class="buttons-container">
        <button
          mat-button
          color="primary"
          type="button"
          (click)="handelFetchReleaseCalendarData()"
        >
          Выбрать
        </button>
        <button
          mat-button
          color="warn"
          type="button"
          (click)="closeDialog('cancel')"
        >
          Закрыть
        </button>
      </div>
    </div>
  }

</app-base-modal>
